import React from 'react'

const InputField = ({
  id, label, type = 'text', error, required, hideLabel = false, className,
  ...inputProps
}) => {
  const labelId = `${id}-label`
  const errorId = error && `${id}-error`

  return (
    <div>
      <label
        id={labelId}
        htmlFor={id}
        className={hideLabel ? 'sr-only' : 'block text-sm font-medium text-gray-700 mb-1'}
      >
        {label}
      </label>
      <input
        id={id}
        type={type}
        required={required}
        // Merge so a caller's className can't drop form-control's base styles.
        className={`form-control ${className || ''}`.trim()}
        aria-labelledby={labelId}
        aria-describedby={errorId || undefined}
        aria-invalid={error ? 'true' : undefined}
        {...inputProps}
      />
      {error && (
        <p id={errorId} role="alert" className="mt-1 text-sm text-danger">
          {error}
        </p>
      )}
    </div>
  )
}

export default InputField
